import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeliPriceService {
  private apiUrl = '/deliprices';
  private apiSpringUrl = '/spring/deliprices';

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    let url:string = '';
    if (ownerId !== undefined) {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    } else {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    }
    return this.http.get(url);
  }

  post(
    ownerId: number,
    carrierCd: string,
    notchargeFl: number,
    prefCd: string,
    sizeCd: string,
    weightCd: string,
    priceNr: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    const jsonInput = {
      ownerId: ownerId,
      carrierCd: carrierCd,
      notchargeFl: notchargeFl,
      prefCd: prefCd,
      delisizeCd: sizeCd,
      deliweightCd: weightCd,
      deliunitpriceNr: priceNr,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    ownerId: number,
    delipriceId: number,
    carrierCd: string,
    notchargeFl: number,
    prefCd: string,
    sizeCd: string,
    weightCd: string,
    priceNr: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${delipriceId}`;
    const jsonInput = {
      ownerId: ownerId,
      carrierCd: carrierCd,
      notchargeFl: notchargeFl,
      prefCd: prefCd,
      sizeCd: sizeCd,
      weightCd: weightCd,
      priceNr: priceNr,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number,
    delipriceId: number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${delipriceId}`;
    return this.http.delete(url);
  }

  upload(file: File, ownerId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/excelupload/${ownerId}`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/deli-price/deli-price.service.ts